/* Rotates the two announcement messages with a quiet cross-fade.
   Respects reduced motion (no rotation — message one stays). */

class AnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
    if (this.messages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.index = 0;
    this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;
    this.setAttribute('aria-live', 'off');
    this.timer = setInterval(() => this.next(), this.interval);

    this.addEventListener('mouseenter', () => clearInterval(this.timer));
    this.addEventListener('mouseleave', () => {
      this.timer = setInterval(() => this.next(), this.interval);
    });
    this.addEventListener('focusin', () => clearInterval(this.timer));
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.timer = setInterval(() => this.next(), this.interval);
      }
    });
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  next() {
    const current = this.messages[this.index];
    this.index = (this.index + 1) % this.messages.length;
    const upcoming = this.messages[this.index];
    current.classList.remove('is-current');
    current.hidden = true;
    upcoming.hidden = false;
    // Force reflow so the fade transition runs after unhiding
    void upcoming.offsetWidth;
    upcoming.classList.add('is-current');
  }
}

if (!customElements.get('announcement-rotator')) {
  customElements.define('announcement-rotator', AnnouncementRotator);
}
